import React from "react";

import GridColumn from "./GridColumn";
import GridFilterCell from "./GridFilterCell";

interface GridFilterRowProps<T> {
    columns: GridColumn<T>[];
    filters: Map<string, any>;
    globalFilter: boolean;

    onClearFilters: () => void;
    filterChanged: (field: string, value: any) => void;
}

class GridFilterRow<T> extends React.Component<GridFilterRowProps<T>> {
    render(): React.ReactNode {
        return (
            <tr className="filter-row">
                {this.props.columns.map((column, index) => (
                    <GridFilterCell
                        key={index}
                        index={index}
                        column={column}
                        globalFilter={this.props.globalFilter}
                        value={this.props.filters.get(column.field)}
                        filterChanged={this.props.filterChanged}
                        onClearFilters={this.props.onClearFilters}
                    />
                ))}
            </tr>
        );
    }
}

export default GridFilterRow;
